import { IconButton } from 'component/Button'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { formatPrice } from 'type/Item'
import css from './ItemHeaderMobile.module.scss'

export const ItemHeaderMobile = observer(() => {
  const demo = useDemo()
  const { show_name } = demo
  const { prices } = demo.product.details ?? {}
  const { item, images } = itemPreview.it
  const { product_name } = item
  const price = formatPrice(item.prices)
  const image = images[0]

  const onClose = useLatestCallback(() => {
    itemPreview.close()
  })

  return (
    <Space gap={8} wide oh>
      <Space>
        {image && <Image className={css.image} src={image} />}
      </Space>
      <Vertical gap={0} oh flex="1 1 0">
        <Typo size={17} line={24} medium upper ellipsis>
          {show_name ? product_name : i18n('Item')}
        </Typo>
        {prices && price && (
          <Typo size={17} line={24} medium primary>
            {price}
          </Typo>
        )}
      </Vertical>
      <Space>
        <IconButton link action={onClose}>
          <Icon size={16} name="close" />
        </IconButton>
      </Space>
    </Space>
  )
})
